import React, {Component} from "react";

import {DurableFunctionHistoryEvent} from "../models/DurableFunctionHistoryEvent";
import moment from "moment";
import {ActionButton, IIconProps} from "office-ui-fabric-react";
import ReactJson from "react-json-view";
import {FRIENDLY_DATETIME_FORMAT} from "../utils/Utils";
import {GroundFloorDurableFunctionInstance} from "../models/DurableFunctionInstance";

const viewIcon: IIconProps = { iconName: 'View' };


interface DurableFunctionHistoryEventListProps
{
    workloadInstance: GroundFloorDurableFunctionInstance;
    durableFunctionHistoryEvents: DurableFunctionHistoryEvent[];
}

interface DurableFunctionHistoryEventListState
{
    jsonObjectName: string;
    jsonObject?: object;
    jsonString?: string;
}

export default class DurableFunctionHistoryEventList extends Component<DurableFunctionHistoryEventListProps,DurableFunctionHistoryEventListState>
{

    constructor(props: DurableFunctionHistoryEventListProps) {
        super(props);

        this.state = {
            jsonObjectName: "",
            jsonObject: undefined,
        }
    }

    public componentDidMount() {
    }

    private createViewJsonButton(jsonObjectName: string, jsonObject: any) {
        
        if(!jsonObject)
        {
            return null;
        }
        
        return (<ActionButton iconProps={viewIcon} allowDisabledFocus disabled={false} checked={false} onClick={async () => {
            
            if(typeof jsonObject === "string")
            {
                try {
                    jsonObject = JSON.parse(jsonObject);
                }
                catch(e)
                {
                    this.setState({
                        jsonObjectName: jsonObjectName,
                        jsonString: jsonObject,
                        jsonObject: undefined,
                    });
                    return;
                }
            }
            
            this.setState({
                jsonObjectName: jsonObjectName,
                jsonObject: jsonObject,
                jsonString: undefined
            });
        }}>
            View
        </ActionButton>);
    }

    private buildRow(durableFunctionHistoryEvent: DurableFunctionHistoryEvent,index: number) : JSX.Element {
        
        const row = (
            <div className="cdb-table__row" key={index}>
                <div className="cdb-table__cell flex-item--flex-2 flex-column">
                    {durableFunctionHistoryEvent.EventType}
                    <span className="cdb-table__extra-detail">{durableFunctionHistoryEvent.FunctionName}</span>
                </div>
                <div className="cdb-table__cell flex-item--flex-2 flex-column">{moment(durableFunctionHistoryEvent.Timestamp).fromNow()}
                    <span className="cdb-table__extra-detail">{moment(durableFunctionHistoryEvent.Timestamp).format(FRIENDLY_DATETIME_FORMAT)}</span>
                </div>
                <div className="cdb-table__cell flex-item--flex-1">{this.createViewJsonButton("Result",durableFunctionHistoryEvent.Result)}</div>
                <div className="cdb-table__cell flex-item--flex-1">{this.createViewJsonButton("Details",durableFunctionHistoryEvent.Details)}</div>
                <div className="cdb-table__cell flex-item--flex-4">{durableFunctionHistoryEvent.Reason}</div>
            </div>
        );

        return row;
    }

    public render() {

        let rows: JSX.Element[] = [];
        if(this.props.durableFunctionHistoryEvents)
        {
            rows = this.props.durableFunctionHistoryEvents
                .sort((a, b) => a.Timestamp >= b.Timestamp ? 1 : -1)
                .map((durableFunctionHistoryEvent, index) => this.buildRow(durableFunctionHistoryEvent, index));
        }
        
        return (
            <div className="flex-row">
                <div className="cdb-table flex-item--flex-1">
                    <div className="card__header">
                        <span className={"card__title"}>Durable Function History</span>
                        {this.props.children}
                    </div>

                    <div className="cdb-table__row cdb-table__row--header">
                        <div className="cdb-table__cell flex-item--flex-2">Event</div>
                        <div className="cdb-table__cell flex-item--flex-2">Timestamp</div>
                        <div className="cdb-table__cell flex-item--flex-1">Result</div>
                        <div className="cdb-table__cell flex-item--flex-1">Details</div>
                        <div className="cdb-table__cell flex-item--flex-4">Reason</div>
                    </div>
                    {rows}
                </div>

                <div className="cdb-table flex-item--flex-1">
                    <div className="card__header">
                        <span className={"card__title"}>History Event</span>
                    </div>

                    <div className="cdb-table__row cdb-table__row--header">
                        <div className="cdb-table__cell flex-item--flex-1">{this.state.jsonObjectName}
                        </div>
                    </div>
                    
                    {this.state.jsonObject ? <ReactJson src={this.state.jsonObject} theme="rjv-default" /> : ""}
                    {this.state.jsonString}
                </div>
            </div>
        );
    }
}